import { Button, Card, Spinner, Typography } from '@material-tailwind/react'
import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import AInput from '../../components/fields/AInput';
import AIcon from '../../components/partials/AIcon';
import UploadPhoto from '../../components/upload/UploadPhoto';
import { useShared } from '../../hooks/useShared';
import { ToastContainer, toast } from 'react-toastify';
import ASpinner from '../../components/partials/ASpinner';
import ABreadcrumbs from '../../components/breadcrumbs/ABreadcrumbs';


const breadcrumbs =[{name:'تنظيمات', link:null}];
const newModelInputFields = [
   
    { label: 'Name In English', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'Please enter the union name in English', isStyle: false, isDisabled: true , dirct:'ltr' },
    { label: 'نام اتحاديه', name: 'name_af', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'Please enter the union name in English', isStyle: false, isDisabled: true },
    { label: 'نام رئيس اتحادیه ', name: 'ceo', type: 'text', roles: [1], icon: 'person-outline', className: '', required: 'Please enter ceo name in English', isStyle: false, isDisabled: true },
    { label: 'شماره تلفون', name: 'phone', type: 'text', roles: [1], icon: 'call-outline', className: '', required: 'Please enter the union phone number',isStyle: false, isDisabled: true, dirct:'ltr' },
    { label: 'ايميل', name: 'email', type: 'email', roles: [1], icon: 'at-outline', className: '', required: 'Please enter the union email address', isStyle: false, isDisabled: true, dirct:'ltr'  },
    { label: 'نام بانک', name: 'bank_name', type: 'text', roles: [1], icon: 'business-outline', className: '', required: 'Please enter bank name', isStyle: false, isDisabled: true },
    { label: 'شماره حساب بانکی', name: 'bank_account', type: 'text', roles: [1], icon: 'card-outline', className: '', required: 'Please enter the union bank account number', isStyle: false, isDisabled: true, dirct:'ltr'  },
    { label: `مصارف قرطاسيه (افغانی)`, name: 'expenses', type: 'number', roles: [1], icon: 'cash-outline', className: '', required: "This field is required!", isStyle: false, isDisabled: true, dirct:'ltr'  },
    { label: 'رنگ اصلی دیتابيس', name: 'main_color', type: 'text', roles: [1], icon: 'color-palette-outline', className: '', required: false, isStyle: false, isDisabled: true },
    { label: 'رنگ فرعی دیتابیس', name: 'subcolor', type: 'text', roles: [1], icon: 'color-palette-outline', className: '', required: false, isStyle: false, isDisabled: true },
    { label: 'ادرس اتحاديه', name: 'address', type: 'textarea', roles: [1], icon: 'location-outline', className: '',  required: 'Please enter the union address', isStyle: false, isDisabled: true },
    { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'albums-outline', className: '',  required: false, isStyle: false, isDisabled: true },
   
];


export default function Settings() {
    const { auth: { user }, http, navigate, uploadPhoto, setModel,model, setPhoto, consts } = useShared()
    const { register, handleSubmit, control, formState: { errors }, reset, setValue } = useForm({});

    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState({ info: false, submit: false })
    const [settings, setSettings] = useState(null)
    const [editInfo, setEditInfo] = useState(false)

    useEffect(() => {
        if(user?.user.is_new_user==0){
         newModelInputFields.map(f => {
             if(f.name !=="email") f.isDisabled = false
         })
         setEditInfo(true)
         
        }
     }, [])

    useEffect(() => {
        setLoading(pre => ({ ...pre, info: true }))
        http.get('api/settings').then(res=>{
          console.log("settings ", res);
        
          if (res.data.success) {
            const data =  res.data.data
            reset(data)
            setModel(data)
            if (res.data) {
                const img = data?.image_data?.path
                setPhoto({ url: img ? consts.BASE_URL + img : '', photo: null })
            }
        }
        setLoading(pre => ({ ...pre, info: false }))
    }, error => {
        setLoading(pre => ({ ...pre, info: false }))

        console.log('Error error');
    }) 
    }, [])



    const submit = async (data) => {
        console.log(data);
        setErrorMessage(null)

    
        console.log('submit ', data);
        try {

            setLoading(pre => ({ ...pre, sumbit: true }))
            const res = await http.post('api/settings', data);
            console.log('settings ', res);
            if (res.data?.success) {
               
            /*     uploadPhoto(res?.data?.data?.attachment ).then(res => {
                    console.log("uploadPhoto " , res)
                   // setPhoto(null)
                }); */
                toast.success(res.data.message);
            }


            setLoading(pre => ({ ...pre, sumbit: false }))

        } catch (error) {
            console.log("error", error);
            setLoading(pre => ({ ...pre, sumbit: false }))
            const err = error?.response?.data
            if (!err?.success) {
                setErrorMessage(err?.message)
                toast.error(err?.message);
            }
        }

    }
    const mReset = () => {
        reset({})
        setErrorMessage(null)
    }

    const handleEnableInputFields = ()=>{
  
        setEditInfo(pre => {
            if(pre){
                newModelInputFields.map(f => {
                   f.isDisabled = true
                })
            }
            else{
                newModelInputFields.map(f => {
                     f.isDisabled = false
                })
            }
            return !pre
        })
        setErrorMessage(null)
    }



    return (
        <div className='relative'>
        <ABreadcrumbs links={breadcrumbs} />
            <div className='md:flex  items-start gap-4' style={{direction:'rtl'}}>

                <Card className="w-full md:w-[70%]  p-2 md:p-4 mt-4 relative">
                    <div className='flex justify-between border-b pb-2'>
                        <p className="text-sm text-main-color font-bold ">{model?.name} Settings</p>
                        <Button onClick={handleEnableInputFields} color="amber" className='py-1 px-2 rounded-full drop-shadow-lg'> <AIcon name="create-outline" size={20} /> </Button>
                    </div>

                    <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>
                        

                            <div className='grid md:grid-cols-1 gap-4'>
                                {
                                    newModelInputFields?.map((data, i) => {
                                        return (
                                            <div key={i}>
                                              
                                                        <AInput v={{ register, errors, data }} />
                                             
                                                
                                            </div>
                                        )
                                    })
                                }
                                {/*    <UploadPhoto v={{ obj: null, className: "md:hidden " }} /> */}
                            </div>
                      
                        {errorMessage && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal "
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}
                        <div className='flex gap-4 md:justify-end'>
                            <Button className="btn1 w-full md:w-[20%]" size='sm' type="submit" disabled={loading.submit  || !editInfo}>  {loading.submit ? <Spinner color="teal" className="h-4 w-4" /> : "Update"}    </Button>

                        </div>


                    </form>
                </Card>

                <div className='w-full  md:w-[30%] '>
                    <UploadPhoto v={{ obj: model?.image_data, className: "pt-4 relative", showSumitButton: true, settings, title:'Upload Profile Photo' }} />
                </div>
            </div>
            {loading.info && <ASpinner />}
            <ToastContainer />
        </div>
    )
}
